import React from 'react';
import { ReadOnlyGuard, SparkIcon, TooltipTrigger } from '@spark';
import RunAllButton from './RunAllButton';

const ToolbarIconButton = ({ tooltip, slug, onClick, disabled, ariaLabel, active }) => (
    <TooltipTrigger text={tooltip} placement="bottom">
        <span>
            <button
                type="button"
                className="pg-icon-button"
                aria-label={ariaLabel}
                aria-pressed={active}
                disabled={disabled}
                onClick={onClick}
            >
                <SparkIcon slug={slug} size="small" />
            </button>
        </span>
    </TooltipTrigger>
);

/**
 * Example actions rail (Figma 1497:59149): add example, shuffle, clear,
 * save to benchmark — 28px secondary icon buttons with tooltips — plus
 * Run all next to the benchmark control (same action as the top bar).
 */
const ExamplesToolbar = ({
    onAddExample,
    onShuffle,
    onClear,
    onSaveToBenchmark,
    onRunAll,
    isRunning,
    runDisabled,
    runDisabledReason,
    clearDisabled,
    shuffleDisabled,
    benchmarkDisabled,
    benchmarkActive,
}) => (
    <div className="pg-examples-toolbar fs-unmask">
        <ToolbarIconButton
            tooltip="Add your own example - Type your input text to test."
            slug="plus"
            ariaLabel="Add example"
            onClick={onAddExample}
        />
        <ToolbarIconButton
            tooltip="Shuffle examples - Load a new random set from your data."
            slug="arrows-shuffle"
            ariaLabel="Shuffle examples"
            disabled={shuffleDisabled}
            onClick={onShuffle}
        />
        <ToolbarIconButton
            tooltip="Clear all examples"
            slug="trash"
            ariaLabel="Clear all examples"
            disabled={clearDisabled}
            onClick={onClear}
        />
        <ReadOnlyGuard>
            <ToolbarIconButton
                tooltip="Save outputs to benchmark - Select the outputs you want to keep."
                slug="bookmark"
                ariaLabel="Save to benchmark"
                disabled={benchmarkDisabled}
                active={benchmarkActive}
                onClick={onSaveToBenchmark}
            />
        </ReadOnlyGuard>
        <RunAllButton
            onRunAll={onRunAll}
            isRunning={isRunning}
            runDisabled={runDisabled}
            runDisabledReason={runDisabledReason}
        />
    </div>
);

export default ExamplesToolbar;
